import { WorkflowDefinitionCard } from './WorkflowDefinitionCard'
import type { WorkflowDefinitionSummary } from '@/types'

interface WorkflowDefinitionsGridProps {
  definitions: WorkflowDefinitionSummary[]
  canDuplicate: boolean
  canToggle: boolean
  canTrigger: boolean
  canDelete: boolean
  onNavigate: (def: WorkflowDefinitionSummary) => void
  onDuplicate: (def: WorkflowDefinitionSummary) => void
  onToggleActive: (def: WorkflowDefinitionSummary) => void
  onTrigger: (def: WorkflowDefinitionSummary) => void
  onDelete: (def: WorkflowDefinitionSummary) => void
}

export function WorkflowDefinitionsGrid({
  definitions,
  canDuplicate,
  canToggle,
  canTrigger,
  canDelete,
  onNavigate,
  onDuplicate,
  onToggleActive,
  onTrigger,
  onDelete,
}: WorkflowDefinitionsGridProps) {
  return (
    <div
      className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
      data-testid="workflow-definitions-grid"
    >
      {definitions.map((definition) => (
        <WorkflowDefinitionCard
          key={definition.id}
          definition={definition}
          canDuplicate={canDuplicate}
          canToggle={canToggle}
          canTrigger={canTrigger}
          canDelete={canDelete}
          onNavigate={onNavigate}
          onDuplicate={onDuplicate}
          onToggleActive={onToggleActive}
          onTrigger={onTrigger}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}
